import { render, staticRenderFns } from "./CaseDispatch.vue?vue&type=template&id=591d5b78&scoped=true&scoped=true&"
import script from "./CaseDispatch.vue?vue&type=script&lang=js&"
export * from "./CaseDispatch.vue?vue&type=script&lang=js&"
import style0 from "./CaseDispatch.vue?vue&type=style&index=0&id=591d5b78&scoped=true&lang=css&"
import style1 from "./CaseDispatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d5b78",
  null
  
)

export default component.exports